import Nullstack from 'nullstack';
export default function IconShareOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-share-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "6",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M15.861 15.896a3 3 0 0 0 4.265 4.22m.578 -3.417a3.012 3.012 0 0 0 -1.507 -1.45"
  }), "   ", Nullstack.element("path", {
    d: "M8.7 10.7l1.336 -.688m2.624 -1.352l2.64 -1.36"
  }), "   ", Nullstack.element("path", {
    d: "M8.7 13.3l6.6 3.4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}